/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchCompetency } from '../../models/match-competency';

export interface GetMatchCompetency$Params {
  id: string;
}

export function getMatchCompetency(http: HttpClient, rootUrl: string, params: GetMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
  const rb = new RequestBuilder(rootUrl, getMatchCompetency.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchCompetency>;
    })
  );
}

getMatchCompetency.PATH = '/matchcompetency/{id}';
